import { useCallback, useEffect, useState } from "react";
import { useUser } from "./useUser";
import { useLocalStorage } from "./useLocalStorage";
import { getStoredUser } from "../util/storage-helpers";

// Initialize synchronously from localStorage to prevent flash on page refresh
const getInitialAuthState = () => {
  const storedUser = getStoredUser();
  if (storedUser) {
    return {
      token: storedUser.token || null,
      role: storedUser.role || null,
    };
  }
  return { token: null, role: null };
};

export const useAuth = () => {
  const { user, addUser, removeUser, setUser } = useUser();
  const { getItem } = useLocalStorage();

  // Initialize synchronously to prevent redirect flash on refresh
  const initialState = getInitialAuthState();
  const [loaded, setLoaded] = useState(true); // Already loaded from sync init
  const [token, setToken] = useState(initialState.token);
  const [role, setRole] = useState(initialState.role);

  const loadInformationFromStorage = useCallback((user: any) => {
    try {
      if (user) {
        const parsed = JSON.parse(user);
        if(parsed && parsed !== null) {
          setToken(parsed.token);
          setRole(parsed.role);
        }
      } else {
        setToken(null);
        setRole(null);
      }
      setLoaded(true);
    }
    catch {
      removeUser();
    }
  }, [removeUser]);


  useEffect(() => {
    const user = getItem("user");
    loadInformationFromStorage(user);
  }, [loadInformationFromStorage, getItem]);

  const login = (user) => {
    addUser(user);
  };

  const logout = () => {
    removeUser();
    setToken(null);
    setRole(null);
  };

  const authenticate = (result) => {
    addUser(result.value);
  };

  return { authenticate, user, token, login, logout, setUser, role, loaded };
};